import { ADAirport, ADDelay, ADResults } from './types'

// TODO: replace with tracker.flightview.com once 'Access-Control-Allow-Origin' has been deployed in production
const host = location.host.endsWith('flightview.com') ? location.host : 'dtracker.flightview.com'

export async function getDelays (): Promise<ADAirport[]> {
  const response = await fetch(`https://${host}/FVDelay/DelayXml.asp`)
  if (response.status !== 200) {
    throw new Error(`Cannot retrieve airport delays the moment: Status Code ${response.status}`)
  }
  const xml = await response.text()
  const parsed = parseXml(xml)
  return parsed.airports
}

function parseXml (xml: string): ADResults {
  const parser = new DOMParser()
  const xmlDoc = parser.parseFromString(xml, 'text/xml')

  const xmlAirports = xmlDoc.getElementsByTagName('Airport')
  const airports = Array.from(xmlAirports).map((xmlAirport): ADAirport => {
    const direction = Array.from(xmlAirport.getElementsByTagName('DelayStatistic'))
    const departures = direction.find((element) => element.getAttribute('Direction') === 'Departures')
    const arrivals = direction.find((element) => element.getAttribute('Direction') === 'Arrivals')
    return {
      airportCode: getUniqueNodeValue(xmlAirport, 'AirportCode'),
      airportName: getUniqueNodeValue(xmlAirport, 'AirportName'),
      departures: ADDelay[departures?.getAttribute('Category') as keyof typeof ADDelay],
      arrivals: ADDelay[arrivals?.getAttribute('Category') as keyof typeof ADDelay]
    }
  })
  return {
    airports
  }
}

function getUniqueNodeValue (xml: Element | XMLDocument, nodeName: string): string {
  const elements = xml.getElementsByTagName(nodeName)
  if (elements && elements.length === 1) {
    return elements[0].firstChild.nodeValue
  } else {
    return null
  }
}
